import { useEffect } from 'react';
export var useDocumentKeydown = function useDocumentKeydown(onKeyDown) {
  useEffect(function () {
    document.getElementsByTagName('body')[0].addEventListener('keydown', onKeyDown);
    return function () {
      return document.getElementsByTagName('body')[0].removeEventListener('keydown', onKeyDown);
    };
  }, [onKeyDown]);
};